import { useActivitiesContext } from '../../../context'
import { useMemo } from 'react'

export function useData() {
  const [{ activities, current }] = useActivitiesContext()
  const currentActivity = useMemo(
    () => activities.find((activity) => activity.id === current),
    [current, activities],
  )

  return {
    currentActivity,
    title: currentActivity?.subject,
  }
}
